//import './vendor/swiper'; // Swiper 7.4.1
//import './vendor/tippy'; // tippy.js v6.3.7
//import './vendor/nouislider'; // tippy.js v6.3.7
//import './vendor/body-scroll-lock';
//import './vendor/fancybox'; // fancybox 4.0.26
import axios from 'axios'; // axios
window.axios = axios;
